// React.
import React from 'react';

// Components.
import AddBundleForm from '../bundles/AddBundleForm';

// Material UI.
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

// Styles.
import { useStyles } from './AddItemStyles';

// Translations.
import { useTranslation } from 'react-i18next';

const AddBundle = () => {
  const classes = useStyles();
  const [t] = useTranslation('global');

  return (
    <Paper className={classes.paper} elevation={3} square={false} variant="elevation">
      <Typography color="primary"  variant="h5" align="inherit">
        <AddCircleOutlineIcon/> { t('bundles.add-bundle-title') }
      </Typography>
      <br/>
      <AddBundleForm/>
    </Paper>
  )
}

export default AddBundle;
